import type { State } from '../../types';

export function today(state: State): string {
  return state.today;
}
